(() => {
  'use strict';

  const API =
    window.ARTOMATOR_PATCH_API_BASE ||
    'https://us-central1-a2-migration.cloudfunctions.net/api';
  const STORAGE_KEY = 'arto.patchProgramReservations.v1';

  const read = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch (_) {
      return {};
    }
  };

  const write = (records) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(records));
    } catch (_) {}
  };

  const request = async (path, options = {}) => {
    const response = await fetch(`${API}${path}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(options.headers || {}),
      },
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(result.message || 'Patch inventory request failed.');
    }
    return result;
  };

  const reservationId = (properties) => {
    if (Array.isArray(properties)) {
      return properties.find(
        (property) => property?.name === '_arto_reservation_id',
      )?.value;
    }
    return properties?._arto_reservation_id;
  };

  let syncing = false;
  const sync = async () => {
    if (syncing) return;
    syncing = true;
    try {
      const cartResponse = await fetch(
        `${window.Shopify?.routes?.root || '/'}cart.js`,
        { headers: { Accept: 'application/json' } },
      );
      if (!cartResponse.ok) return;
      const cart = await cartResponse.json();
      const activeIds = new Set(
        (cart.items || [])
          .map((item) => reservationId(item.properties))
          .filter(Boolean),
      );
      const records = read();

      await Promise.all(
        Object.entries(records).map(async ([id, record]) => {
          const path = `/patch-programs/reservations/${encodeURIComponent(id)}`;
          try {
            if (activeIds.has(id)) {
              const result = await request(`${path}/refresh`, {
                method: 'POST',
                body: JSON.stringify({ reservationToken: record.token }),
              });
              records[id] = {
                ...record,
                expiresAt: result.expiresAt,
                seenInCart: true,
              };
            } else if (
              record.seenInCart ||
              Date.now() - Number(record.createdAt || 0) > 120000
            ) {
              await request(path, {
                method: 'DELETE',
                body: JSON.stringify({ reservationToken: record.token }),
              });
              delete records[id];
            }
          } catch (_) {
            delete records[id];
          }
        }),
      );
      write(records);
    } finally {
      syncing = false;
    }
  };

  window.ArtoPatchInventory = {
    apiBase: API,
    request,
    remember(id, token, expiresAt) {
      const records = read();
      records[id] = { token, expiresAt, createdAt: Date.now() };
      write(records);
    },
    sync,
  };

  window.addEventListener('pageshow', sync);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') sync();
  });
  window.setInterval(sync, 60000);
})();
